import Image from "next/image";

type SliderRowProps = {
  images: string[];
  direction: "ltr" | "rtl";
};

export const SliderRowW: React.FC<SliderRowProps> = ({ images, direction }) => {
  const animation =
    direction === "ltr" ? "animate-slide-ltr" : "animate-slide-rtl";

  return (
    <div className="overflow-hidden">
      <div className={`flex w-[200%] gap-6 ${animation}`}>
        {[...images, ...images].map((src, idx) => (
          <div
            key={idx}
            className="
              relative
              aspect-[16/9]
              h-[26vh] md:h-[32vh] lg:h-[36vh]
              shrink-0
              overflow-hidden
            "
          >
            <Image
              src={src}
              alt=""
              fill
              priority={idx < 3}
              sizes="(min-width: 1024px) 28vw, (min-width: 768px) 40vw, 80vw"
              className="object-cover"
            />
          </div>
        ))}
      </div>
    </div>
  );
};
